import { BaseLayout } from "@components/general/base_layout";
import { Outlet } from "react-router-dom";

export const MarketplacePage = () => {
  return (
    <BaseLayout>
      <Outlet />
    </BaseLayout>
  );
};
